import { render, staticRenderFns } from "./boxExample.vue?vue&type=template&id=127f1cb0&scoped=true&"
import script from "./boxExample.vue?vue&type=script&lang=js&"
export * from "./boxExample.vue?vue&type=script&lang=js&"
import style0 from "./boxExample.vue?vue&type=style&index=0&id=127f1cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f1cb0",
  null
  
)

export default component.exports